import classnames from 'classnames';
import React from 'react';
import { Button } from '@blueprintjs/core';

export default class DataTableKetQua extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      divHeight: 195,
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps() {
    let divHeight = 0;
    let obj = document.getElementsByClassName('table-header')[0];

    if (obj && obj.offsetHeight) {
      divHeight = obj.offsetHeight;
    } else if (obj && obj.style && obj.style.pixelHeight) {
      divHeight = obj.style.pixelHeight;
    }
    this.setState({
      divHeight: divHeight + 2,
    });
  }

  componentDidMount() {
    let divHeight = 0;
    let obj = document.getElementsByClassName('table-header')[0];

    if (obj && obj.offsetHeight) {
      divHeight = obj.offsetHeight;
    } else if (obj && obj.style.pixelHeight) {
      divHeight = obj.style.pixelHeight;
    }
    this.setState({
      divHeight: divHeight + 2,
    });
  }

  renderHeaderTable({ header, numberColumnHeader }) {
    const column = header.map((headerItems, i) => {
      let items = [];
      items = [...headerItems];

      return (
        <tr key={i}>
          {items.map((item, j) => {
            return (
              <th
                key={j}
                className={`table-header-col ${item.className || ''}`}
                colSpan={item.colSpan || 1}
                rowSpan={item.rowSpan || 1}
                style={{
                  maxWidth: item.maxWidth,
                  width: item.width,
                  minWidth: item.minWidth,
                }}
              >
                {item.name}
              </th>
            );
          })}
        </tr>
      );
    });

    const numberColumn = (
      <tr>
        {Array.from(Array(numberColumnHeader).keys()).map((item, i) => {
          return (
            <th className='txt-center' key={i}>
              {item + 1}
            </th>
          );
        })}
      </tr>
    );

    return (
      <thead className='table-header'>
        {column}
        {numberColumnHeader && numberColumn}
      </thead>
    );
  }

  renderContentTable({ tableLoading, children, header }) {
    const renderLoading = (
      <div className='loading-content'>
        <span className='shape1'></span>
        <span className='shape2'></span>
        <span className='shape3'></span>
        <span className='shape4'></span>
        <span className='shape5'></span>
        <span className='shape6'></span>
        <span className='shape7'></span>
        <span className='shape8'></span>
        <span className='shape9'></span>
        <span className='shape10'></span>
        <span className='shape11'></span>
        <span className='shape12'></span>
        <span className='shape13'></span>
      </div>
    );

    return (
      <tbody className='table-body'>
        {tableLoading ? (
          <tr className='table-loading'>
            <td colSpan={header.length}>
              {renderLoading}
              {renderLoading}
              {renderLoading}
            </td>
          </tr>
        ) : (
          children
        )}
      </tbody>
    );
  }

  handleDown(e) {
    if (this.props.touchMove) {
      let Item = document.getElementById('scrollItem');
      document.getElementById('scrollItem').classList.add('scrolling');
      this.state.down = true;
      this.state.scrollLeft = Item.scrollLeft;
      this.state.x = e.clientX;
    }
  }

  handleUp() {
    if (this.props.touchMove) {
      document.getElementById('scrollItem').classList.remove('scrolling');
      this.state.down = false;
    }
  }

  handleMove(e) {
    if (this.props.touchMove) {
      let Item = document.getElementById('scrollItem');
      if (this.state.down == true) {
        Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
      }
    }
  }

  handleLeave() {
    if (this.props.touchMove) {
      document.getElementById('scrollItem').classList.remove('scrolling');
      this.state.down = false;
    }
  }

  handleExport() {
    this.props.handleExport();
  }

  render() {
    const {
      header,
      touchMove,
      children,
      tableLoading,
      numberColumnHeader,
      exportText,
    } = this.props;
    const { renderHeaderTable, renderContentTable } = this;

    return (
      <div className='wrapper-table wrapper-tkbc'>
        <div
          className={classnames('table-container', {
            'touch-move': touchMove,
          })}
          style={{ overflowY: 'clip' }}
          id='scrollItem'
          onMouseUp={this.handleUp.bind(this)}
          onMouseDown={this.handleDown.bind(this)}
          onMouseMove={this.handleMove.bind(this)}
          onMouseLeave={this.handleLeave.bind(this)}
        >
          <table className='table-content'>
            {renderHeaderTable({ header, numberColumnHeader })}
            {renderContentTable({ tableLoading, children, header })}
          </table>
        </div>
        {exportText && (
          <Button
            className='btn-green tt-export mt15'
            text={exportText || 'Xuất Excel'}
            onClick={this.handleExport.bind(this)}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/data-table/DataTableKetQua.jsx